export const I18n = {
	'en': {
		modal: {
			sure: 'Are you sure ?',
			delete: 'Delete',
			save: 'Save',
			cancel: 'Cancel',
			changeCompany: 'Edit company',
			phone: 'Phone',
			email: 'Email',
			companyTitle: 'Name',
			type: 'Type',
			country: 'Country',
			city: 'City',
			language: 'Language',
			manager: 'Manager',
			mail: 'Mail',
			skype: 'Skype',
			status: 'Status',
			statusPending: 'Pending',
			statusActive: 'Active',
			statusBlocked: 'Blocked',
			companyAttributes: 'Company Attributes'
		},
		companiesTitle: 'Companies List',
		companyNamePlaceholder: 'Search by name',
		status: 'Status',
		statusPending: 'Pending',
		statusActive: 'Active',
		statusBlocked: 'Blocked',
		type: 'Type',
		typeRetail: 'Retail network',
		typeDev: 'Developer',
		typeOperator: 'Mobile operator',
		clearFilters: 'Clear filters',
		addOrganisation: 'Add organisation',
		organisation: 'Organisation',
		tableType: 'Type',
		noType: 'none',
		manager: 'Manager',
		companyTraders: 'Traiders network',
		companyDev: 'Developer',
	},
	'ru': {
		modal: {
			sure: 'Вы уверены ?',
			delete: 'Удалить',
			save: 'Сохранить',
			cancel: 'Отмена',
			changeCompany: 'Изменить компанию',
			phone: 'Телефон',
			email: 'Мейл',
			companyTitle: 'Название',
			type: 'Тип',
			country: 'Страна',
			city: 'Город',
			language: 'Язык',
			manager: 'Менеджер',
			mail: 'Почта',
			skype: 'Скайп',
			status: 'Статус',
			statusPending: 'В ожидании',
			statusActive: 'Активный',
			statusBlocked: 'Заблокирован',
			companyAttributes: 'Атрибуты компании'
		},
		companiesTitle: 'Список компаний',
		companyNamePlaceholder: 'Поиск по названию',
		status: 'Статус',
		statusPending: 'В ожидании',
		statusActive: 'Активный',
		statusBlocked: 'Заблокирован',
		type: 'Тип организации',
		typeRetail: 'Торговая сеть',
		typeDev: 'Разработчик',
		typeOperator: 'Мобильный оператор',
		clearFilters: 'Сбросить фильтры',
		addOrganisation: 'Добавить организацию',
		organisation: 'Организация',
		tableType: 'Тип',
		noType: 'не определен',
		manager: 'Менеджер',
		companyTraders: 'Торговая сеть',
		companyDev: 'Разработчик',
	},
	'sk': {
		modal: {
			sure: 'Si si istý ?',
			delete: 'Vymazať',
			save: 'Uložiť',
			cancel: 'Zrušiť',
			changeCompany: 'Editovať spoločnosť',
			phone: 'Telefón',
			email: 'E-mail',
			companyTitle: 'Názov',
			type: 'Typ',
			country: 'Krajina',
			city: 'Veľkomesto',
			language: "Jazyk",
			manager: 'Manažér',
			mail: 'Pošta',
			skype: 'Skype',
			status: 'Postavenie',
			statusPending: 'Nevykonaného',
			statusActive: 'Aktívny',
			statusBlocked: 'Upchatý',
			companyAttributes: 'Atribúty Firemné'
		},
		companiesTitle: 'Zoznam firiem',
		companyNamePlaceholder: 'Vyhľadávanie podľa mena',
		status: 'Postavenie',
		statusPending: 'Nevykonaného',
		statusActive: 'Aktívny',
		statusBlocked: 'Upchatý',
		type: 'Typ',
		typeRetail: 'Maloobchodná sieť',
		typeDev: 'Vývojka',
		typeOperator: 'Mobilný operátor',
		clearFilters: 'Vymazať filtre',
		addOrganisation: 'Pridajte organizácie',
		organisation: 'Organizácia',
		tableType: 'Typ',
		noType: 'Nikto',
		manager: 'Manažér',
		companyTraders: 'Traiders siete',
		companyDev: 'Vývojka',
	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/Companies/index.js